class TkShippingBar extends HTMLElement {
  #debounceTimer = null;

  connectedCallback() {
    this.steps = JSON.parse(this.dataset.steps || '[]');
    if (!this.steps.length) return;

    const requiresShipping = this.dataset.requiresShipping !== 'false';
    this.classList.toggle('is-no-shipping', !requiresShipping);
    this.setProgress(requiresShipping ? parseInt(this.dataset.cartTotal || '0', 10) : 0);
    this.#watchCartChanges();
  }

  #watchCartChanges() {
    const schedule = () => {
      clearTimeout(this.#debounceTimer);
      this.#debounceTimer = setTimeout(() => this.#fetchAndUpdate(), 200);
    };

    const targets = [
      '#CartDrawer-CartItems',
      '#main-cart-items',
      '#cart-icon-bubble',
    ]
      .map((s) => document.querySelector(s))
      .filter(Boolean);

    const observer = new MutationObserver(schedule);
    targets.forEach((el) => observer.observe(el, { childList: true }));

    document.addEventListener('cart:refresh', schedule);
  }

  async #fetchAndUpdate() {
    try {
      const { total_price, requires_shipping } = await fetch('/cart.js').then((r) => r.json());
      this.classList.toggle('is-no-shipping', !requires_shipping);
      this.setProgress(requires_shipping ? total_price : 0);
    } catch (_) {}
  }

  #formatAmount(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
      }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2);
    }
  }

  setProgress(totalCents) {
    let fillPct = 0;
    let prevCents = 0;
    let prevPos = 0;

    for (const step of this.steps) {
      if (totalCents < step.threshold) {
        const rangeCents = step.threshold - prevCents;
        const rangePos = step.position - prevPos;
        fillPct = prevPos + ((totalCents - prevCents) / rangeCents) * rangePos;
        break;
      }
      prevCents = step.threshold;
      prevPos = step.position;
      fillPct = 100;
    }

    fillPct = Math.min(100, Math.max(0, fillPct));
    this.querySelector('.tk-shipping-bar__fill').style.width = `${fillPct.toFixed(2)}%`;

    this.querySelectorAll('.tk-shipping-bar__milestone').forEach((el, i) => {
      el.classList.toggle('is-reached', totalCents >= this.steps[i].threshold);
    });

    this.#updateMessage(totalCents);
  }

  #updateMessage(totalCents) {
    const msgEl = this.querySelector('.tk-shipping-bar__message');
    if (!msgEl) return;

    if (this.classList.contains('is-no-shipping')) {
      msgEl.innerHTML = this.dataset.noShippingMessage || '';
      return;
    }

    let text = '';
    let found = false;

    for (const step of this.steps) {
      if (totalCents < step.threshold) {
        const missing = step.threshold - totalCents;
        text = (step.message || '').replace('[amount]', this.#formatAmount(missing));
        found = true;
        break;
      }
    }

    if (!found) {
      text = this.dataset.successMessage || '';
    }

    msgEl.innerHTML = text;
  }
}

customElements.define('tk-shipping-bar', TkShippingBar);
